<template>
  <button
    :class="`btn-${color}` + (small ? ' btn-sm py-1 ps-1' : '')"
    :disabled="disabled || active"
    class="btn pe-2"
    @click="handler"
  >
    <span style="white-space: nowrap">
      <span :style="{ paddingLeft: active ? `0px` : `8px`, paddingRight: active ? `0px` : `2px` }">
        <template v-if="text">{{ tr(text) }}</template>
        <slot v-else />
      </span>
      <span
        :style="{ visibility: active ? `visible` : `hidden`, maxWidth: active ? null : 0 }"
        class="spinner d-inline-block"
        style="margin-bottom: -3px; margin-top: 2px; margin-left: 4px"
      />
    </span>
  </button>
</template>

<script>
  import { tr } from '~/assets/scripts/helpers'

  export default {
    name: 'LoadingButton',
    props: {
      text: { type: String, default: null },
      color: { type: String, default: 'primary' },
      method: { type: Function, default: null },
      methodData: { type: [Object, String, Number, Array, null], default: null },
      disabled: { type: Boolean, default: false },
      small: { type: Boolean, default: false },
    },
    data() {
      return {
        active: false,
      }
    },
    methods: {
      tr,
      handler() {
        if (this.method !== undefined && this.method !== null) {
          this.active = true
          if (this.methodData !== null) {
            this.method(this.methodData)
              .then(() => {
                this.active = false
              })
              .catch((err) => {
                this.active = false
                throw err
              })
          } else {
            this.method()
              .then(() => {
                this.active = false
              })
              .catch((err) => {
                this.active = false
                throw err
              })
          }
        }
      },
    },
  }
</script>

<style scoped>
  .spinner {
    border: 5px solid #f3f3f3; /* Light grey */
    border-top: 5px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 1.1em;
    height: 1.1em;
    padding: 0;
    display: inline-block;
    /*margin-left: auto;*/
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
